<template>
  <b-modal
    v-model="localShowDetailModal"
    centered
    :title="modalTitle"
    @hide="$emit('close')"
    hide-header-close
  >
    <div v-if="selectedItems" class="d-flex flex-column gap-3">
      <span>{{ modalMessage }}</span>
      <ul style="max-height: 300px; overflow-y: auto">
        <li v-for="item in selectedItems || []" :key="item.id">
          {{ item?.training?.title || item?.id }}
        </li>
      </ul>
    </div>

    <template #modal-footer>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div v-if="!isReject" class="text-danger small">
          <i class="fe fe-alert-circle"></i>
          <span>
            Other trainings except the above mentioned data will be
            automatically rejected.
          </span>
        </div>
        <div v-else></div>
        <b-button
          :variant="isReject ? 'danger' : 'primary'"
          :disabled="isSubmitting"
          @click="handleSubmit"
        >
          {{ isReject ? "Reject" : "Approve" }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { titleCase } from "@/utils/titleCase";

export default {
  name: "ConfirmationSubmitModal",
  props: {
    showConfirmationSubmit: {
      type: Boolean,
      default: false,
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    isReject: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localShowDetailModal: {
      get() {
        return this.showConfirmationSubmit;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    modalTitle() {
      return this.isReject ? "Reject Training" : "Approve Training";
    },
    modalMessage() {
      return this.isReject
        ? "Apakah Anda yakin ingin menolak pelatihan ini?"
        : "Apakah Anda yakin ingin menyetujui pelatihan ini?";
    },
  },
  methods: {
    titleCase,
    handleSubmit() {
      const ids = this.selectedItems.map((row) => row.id);

      this.$emit("submit", ids);
    },
  },
};
</script>

<style scoped>
.gap-2 > * + * {
  margin-left: 0.5rem;
}

.table td {
  padding: 0.5rem 0;
}

.d-flex.flex-wrap {
  row-gap: 0.25rem;
  column-gap: 0.25rem;
}

.completion-badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>
